import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createAppointmentSlice = createAsyncThunk(
  "appointment/createAppointment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/appointment/createAppointment",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const cancelAppointment = createAsyncThunk(
  "appointment/cancelAppointment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/appointment/cancelAppointment",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAppointmentSlice = createAsyncThunk(
  "appointment/getAllAppointmentDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/appointment/getAllAppointmentDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAppointmentRegistrationState = createAsyncThunk(
  "appointment/getAppointmentRegistrationState",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/appointment/getAppointmentRegistrationState",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPrescriptionDetails = createAsyncThunk(
  "appointment/getPrescriptionDetails",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/appointment/getPrescriptionDetails",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
)

const initialState = {
  loading: false,
  appointmentCreateSuccessMessage: null,
  appointmentCreateErrorMessage: null,
  
cancelSuccessMessage: null,   
  cancelErrorMessage: null, 
  appointments: [],
  prescriptionInfo: null,
  searchMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
  appointmentStats: {
    yesterdayAppointmentCount: 0,
    todayAppointmentCount: 0,
    registrationApptPercentage: "0%",
  },
};

const appointmentSlice = createSlice({
  name: "appointment",
  initialState,
  reducers: {
    resetAppointmentCreateMessage: (state) => {
      state.appointmentCreateSuccessMessage = null;
      state.appointmentCreateErrorMessage = null;
    },
    resetgetAppointment: (state) => {
      state.appointments = [];
      state.currentPage = 1;
      state.hasMore = true;
    },
    resetAppointmentData: (state) => {
      state.appointments = [];
      state.patientData = null;
      state.appointmentStats = {
        yesterdayPatientCount: 0,
        todayPatientCount: 0,
        registrationApptPercentage: "0%",
      };
    },
    resetCancelMessage: (state) => {
      state.cancelSuccessMessage = null;
      state.cancelErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAppointmentSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAppointmentSlice.fulfilled, (state, action) => {
        if (action.payload.success === false) {
          state.appointmentCreateErrorMessage = action.payload.result.message;
        } else {
          state.appointmentCreateSuccessMessage = action.payload.result.message;
        }
        state.loading = false;
      })
      .addCase(createAppointmentSlice.rejected, (state, action) => {
        state.loading = false;
        state.appointmentCreateErrorMessage = action.payload;
      })
      .addCase(getAppointmentSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppointmentSlice.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.success) {
          state.appointments = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.currentPage = 1;
          state.hasMore = false;
          state.searchMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.appointments = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.hasMore = result.hasMore ?? false;
        state.searchMessage = null;
      })
      .addCase(getAppointmentSlice.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAppointmentRegistrationState.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAppointmentRegistrationState.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.errorMessage = action.payload.result.message;
        } else {
          state.appointmentStats = action.payload.result.list;
        }
      })

      .addCase(getAppointmentRegistrationState.rejected, (state, action) => {
        state.loading = false;
        state.cancelErrorMessage = action.payload;
      })
      .addCase(getPrescriptionDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPrescriptionDetails.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.errorMessage = action.payload.result.message;
        } else {
          state.prescriptionInfo = action.payload.result;
        }
      })
      .addCase(getPrescriptionDetails.rejected, (state, action) => {
        state.loading = false;
        state.cancelErrorMessage = action.payload;
      })
      .addCase(cancelAppointment.pending, (state) => {
        state.loading = true;
      })
      .addCase(cancelAppointment.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.success === false) {
          state.cancelErrorMessage = action?.payload?.result?.message;
        } else {
          state.cancelSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(cancelAppointment.rejected, (state, action) => {
        state.loading = false;
        state.cancelErrorMessage = action?.payload;
      });
      

  },
});
export const {
  resetAppointmentCreateMessage,
  resetgetAppointment,
  resetAppointmentData,
  resetCancelMessage,
} = appointmentSlice.actions;
export default appointmentSlice.reducer;
